import { t } from 'i18next';

const PROPERTIES = {
    AccessionNumber: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    AdmissionDepartment: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    Age: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    DateRange: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    DoB: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    ExternalID: {
        isColumn: true,
        isSortable: false,
        isFilter: true,
    },
    Halls: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    InvoiceAmount: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    InvoiceStatus: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    InvoiceStatuses: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    IsSelected: {
        isColumn: true,
        isSortable: false,
        isFilter: false,
    },
    Labels: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    LabelsToExcludeIDs: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    LabelsToIncludeIDs: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    Language: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    ModalityIDs: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    NationalNumber: {
        isColumn: true,
        isSortable: false,
        isFilter: true,
    },
    OrderDateTimePrescription: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    OrderNumber: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    OrderStatus: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    Patient: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    PatientFirstName: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    PatientLastName: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    PatientLocation: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    PatientOrigin: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    PatientStatus: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    ProcedureCodes: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ProcedureDescription: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ProcedureImplementationDate: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    Procedures: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ProcedureStatus: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    Radiologist: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    Radiologists: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReadyForInvoicing: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    Remarks: {
        isColumn: true,
        isSortable: false,
        isFilter: false,
    },
    RequestingPhysician: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    RequestingPhysicianFirstName: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    RequestingPhysicianLastName: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    Technicians: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    RoomsIDs: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    UrgencyIds: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    SiteIDs: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    Sites: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    Technician: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    UnitOfCare: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    Urgencies: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    VisitNumber: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    Justification: {
        isColumn: true,
        isSortable: true,
        isFilter: true,
    },
    ReportSupervisor: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportReviewer: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportValidatedBy: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportTranscribedBy: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportCreatedBy: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportCreatedDateTime: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportValidatedDateTime: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportStatus: {
        isColumn: true,
        isSortable: true,
        isFilter: false,
    },
    ReportLocked: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReportAvailable: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReportStatuses: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReportModifiedBy: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReportModifiedDateRange: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReportCreatedDateRange: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReportParticipants: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    ReportParticipantType: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
    Transcriptionists: {
        isColumn: false,
        isSortable: false,
        isFilter: true,
    },
} as const satisfies PropertyConfig;

/** Translation key used as the column/filter title for each worklist property. */
const TITLE_TRANSLATION_KEYS: Record<Exclude<WorklistPropery, 'PatientStatus'>, string> = {
    AccessionNumber: 'AccessionNumber',
    AdmissionDepartment: 'AdmissionDepartment',
    Age: 'Age',
    DateRange: 'ImplementationDate',
    DoB: 'dateOfBirthShort',
    ExternalID: 'ExternalNumber',
    Halls: 'Halls',
    InvoiceAmount: 'InvoiceAmount',
    InvoiceStatus: 'InvoiceStatus',
    InvoiceStatuses: 'InvoiceStatus',
    IsSelected: 'SelectionColumn',
    Labels: 'Label',
    LabelsToExcludeIDs: 'LabelsToExclude',
    LabelsToIncludeIDs: 'LabelsToInclude',
    Language: 'Language',
    ModalityIDs: 'Modality',
    NationalNumber: 'NationalRegisterNumber',
    OrderDateTimePrescription: 'DateOfPrescriptionShort',
    OrderNumber: 'OrderNumber',
    OrderStatus: 'OrderStatus',
    Patient: 'PatientName',
    PatientFirstName: 'PatientFirstName',
    PatientLastName: 'PatientLastName',
    PatientLocation: 'PatientLocation',
    PatientOrigin: 'PatientOrigin',
    ProcedureCodes: 'ProcedureCode',
    ProcedureDescription: 'ProcedureDescription',
    ProcedureImplementationDate: 'ImplementationDate',
    Procedures: 'Procedure',
    ProcedureStatus: 'ProcedureStatus',
    Radiologist: 'Radiologist',
    Radiologists: 'Radiologist',
    ReadyForInvoicing: 'ReadyForInvoicing',
    Remarks: 'Remark',
    RequestingPhysician: 'Applicant',
    RequestingPhysicianFirstName: 'RequestingPhysicianFirstName',
    RequestingPhysicianLastName: 'RequestingPhysicianLastName',
    RoomsIDs: 'Hall',
    SiteIDs: 'Site',
    Sites: 'Site',
    Technician: 'Technician',
    Technicians: 'Technician',
    UnitOfCare: 'CareUnitCode',
    Urgencies: 'Urgency',
    UrgencyIds: 'Urgency',
    VisitNumber: 'VisitNumber',
    Justification: 'Justification',
    ReportSupervisor: 'ReportSupervisor',
    ReportReviewer: 'ReportReviewer',
    ReportValidatedBy: 'ReportValidatedBy',
    ReportTranscribedBy: 'ReportTranscribedBy',
    ReportCreatedBy: 'ReportCreatedBy',
    ReportCreatedDateTime: 'ReportCreated',
    ReportValidatedDateTime: 'ReportValidated',
    ReportStatus: 'Report',
    ReportLocked: 'Locked',
    ReportAvailable: 'ReportAvailable',
    ReportStatuses: 'ReportStatus',
    ReportModifiedBy: 'ReportModifiedBy',
    Transcriptionists: 'ReportTranscribedBy',
    ReportCreatedDateRange: 'ReportCreated',
    ReportModifiedDateRange: 'ReportModified',
    ReportParticipants: 'ReportParticipant',
    ReportParticipantType: 'ReportParticipantType',
};

export const getTitleForWorklistProperty = (property: WorklistPropery): string => {
    // Fixed abbreviation for Ambulatory/Hospitalised, identical in every language.
    if (property === 'PatientStatus') {
        return 'A/H';
    }

    return t(TITLE_TRANSLATION_KEYS[property]);
};

type WorklistPropery = keyof typeof PROPERTIES;
export type WorklistColumn = { [K in keyof typeof PROPERTIES]: typeof PROPERTIES[K] extends { isColumn: true } ? K : never }[keyof typeof PROPERTIES];
export type SortableWorklistColumn = { [K in keyof typeof PROPERTIES]: typeof PROPERTIES[K] extends { isColumn: true; isSortable: true } ? K : never }[keyof typeof PROPERTIES];
export type WorklistFilterProperty = { [K in keyof typeof PROPERTIES]: typeof PROPERTIES[K] extends { isFilter: true } ? K : never }[keyof typeof PROPERTIES];

export const ALL_WORKLIST_COLUMNS = (Object.keys(PROPERTIES) as (keyof typeof PROPERTIES)[]).filter(
    (key) => PROPERTIES[key].isColumn,
) as WorklistColumn[];

export const ALL_WORKLIST_FILTER_PROPERTIES = (Object.keys(PROPERTIES) as (keyof typeof PROPERTIES)[]).filter(
    (key) => PROPERTIES[key].isFilter,
) as WorklistFilterProperty[];

export const isWorklistColumn = (column: string): column is WorklistColumn => {
    return column in PROPERTIES && PROPERTIES[column as keyof typeof PROPERTIES].isColumn;
};

export const isWorklistColumnSortable = (column: string): column is SortableWorklistColumn => {
    return column in PROPERTIES
        && PROPERTIES[column as keyof typeof PROPERTIES].isColumn
        && PROPERTIES[column as keyof typeof PROPERTIES].isSortable;
};

type PropertyConfig = Record<string, { isColumn: true; isSortable: boolean; isFilter: boolean } | { isColumn: false; isSortable: false; isFilter: boolean }>;
